<template>
<div>
    <header-nav :index_num="index_num"></header-nav>
  <div class="box">

    <div class="box1">
      <p class="title">一、项目申报书</p>
      <a class="link">预览</a>|
      <a class="link">下载</a>
    </div>
    <div class="box1">
      <p class="title">二、项目实施方案</p>
      <a class="link">预览</a>|
      <a class="link">下载</a>
    </div>
    <div class="box1">
      <p class="title">三、中期报告</p>
    </div>
    <div class="box1">
      <p class="title">1.基本信息</p>
    </div>
    <div class="box1">
      <p>
        <span class="title">项目名称：</span>
        <span>世界婚博会</span>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">机构名称：</span>
        <span>世界婚博会</span>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">项目起止日期：</span>
        <span>世界婚博会</span>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">项目执行团队人员构成及分工：</span>
        <span>世界婚博会</span>
      </p>
    </div>
    <div class="box1">
      <p class="article">
        <span class="title">2.项目发展性状况：</span>
        <span>我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
        <p class="article">
<span class="title">3.1 项目目标</span>
        <span>我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
        </p>
        
    </div>
    <div class="box1">
      <p class="article">
        <span class="title">3.2 项目活动</span>
        <span >我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p class="article">
        <span class="title">3.3项目中期完成目标与活动对照表</span>
        <span class="article">我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">4项目取得的成效</span>
      </p>
    </div>
    <div class="box1">
      <p  class="article">
        <span class="title">4.1 项目活动</span>
        <span>我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p class="article">
        <span class="title">4.2 项目产生的其他重要影响</span>
        <span >我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p class="article">
        <span class="title">4.3 媒体报道</span>
        <span >我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p  class="article">
        <span class="title">5.对项目实施至今整体情况的总结：</span>
        <span>我国仍处于并将长期处于社会主义初级阶段，是最大的国情和实际。“我们开展各项工作，要一切从实际出发，牢牢立足这个最大国情和实际，不要超越阶段。从能源来看，我国‘富煤少油缺气’的资源禀赋，决定了煤炭在较长一个时期内作为我国主体能源的地位不会发生变化，这就要求我们坚持从煤炭资源丰富的国情出发，切实抓好煤炭清洁高效利用。”章建华说。</span>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">6.项目财务报告</span>
        <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">四、项目调整申请表及批复意见表</span>
        <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
    <div class="box1">
      <p>
        <span class="title">五、活动类/培训类/会议类材料</span>
      </p>
    </div>
        <div class="box1">
      <p>
        <span>xxx活动</span>
           <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
            <div class="box1">
      <p>
        <span>xxx活动</span>
           <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
            <div class="box1">
      <p>
        <span>xxx活动</span>
           <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
        <div class="box1">
      <p>
        <span class="title">六、财务中期预算表</span>
        <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
            <div class="box1">
      <p>
        <span class="title">七、其他类 </span>
        <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
            <div class="box1">
      <p>
        <span class="title">八、中期PPT文件 </span>
        <a class="link">预览</a>|
        <a class="link">下载</a>
      </p>
    </div>
  </div>
</div>

</template>

<script>
import HeaderNav from "../components/HeaderNav";
export default {
  name: "middetail",
  components: {
    HeaderNav
  },
  data() {
    return {
      index_num: 0
    };
  }
};
</script>

<style lang='scss' scoped>
.box {
        margin-left: 28px;
    margin-top: 16px;
  .box1{
    display: flex;
    margin-top:27px;
  }
  .title {
    font-weight: bold;
    margin-right: 11px;
  }
  .link {
    color: #5f73e1;
  }
  .article{
      width: 1000px;
      line-height: 30px;
  }
}
</style>